<template>
    <div>
        <el-alert title="专业和科目都以本年为主,如果今年科目有所变更，可重新新增专业和科目系统默认获取本年的数据。专业编码个年份是唯一的，强行新增会覆盖" type="info"  show-icon :closable="false"></el-alert>
        <div v-show="!saveOrUpdate.visible&&!look.visible">
            <!--搜索表单-->
            <div class="search-box">
                <el-form ref="searchForm" :rules="rules"  :inline="true" :model="searchForm" >
                    <el-form-item label="年份:" prop="year">
                        <el-date-picker
                                style="width: 200px"
                                size="mini"
                                v-model="searchForm.year"
                                type="year"
                                placeholder="选择年份"
                                format="yyyy"
                                value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                     <el-form-item label="专业名称:" prop="name">
                        <el-input size="mini" v-model="searchForm.name" placeholder="请输入专业名称"></el-input>
                    </el-form-item>
                    <el-form-item label="科目类型:" prop="type">
                        <el-select size="mini" filterable v-model="searchForm.type" placeholder="请选科目类型">
                            <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysMajor-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh-left" @click="clear">清空</el-button>
                        <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysMajor-editModule icon="el-icon-edit" @click="editModule" >编辑科目模板</el-button>
                        <el-button plain size="mini" type="primary" v-display:sysMajor-save icon="el-icon-plus" @click="toSaveOrUpdate" >新增</el-button>
                        <el-dropdown>
                            <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-display:sysMajor-batchSave icon="el-icon-tickets" @click.native="batchSave" >复制科目模板</el-dropdown-item>
                              <el-dropdown-item v-display:sysMajor-batchSave icon="el-icon-tickets" @click.native="batchSaveUpYear" >复制上年度专业科目</el-dropdown-item>
                              <el-dropdown-item v-display:sysMajor-batchUpdate icon="el-icon-edit" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                                <el-dropdown-item v-display:sysMajor-batchDelete icon="el-icon-delete" @click.native="batchDelete" >批量删除</el-dropdown-item>
                                <el-dropdown-item v-display:sysMajor-leadingIn icon="el-icon-upload" @click.native="leadingInsysMajor">导入</el-dropdown-item>
                                <el-dropdown-item v-display:sysMajor-export icon="el-icon-download" @click.native="exportsysMajor">导出</el-dropdown-item>
                                <el-dropdown-item v-display:sysMajor-exportModule icon="el-icon-download" @click.native="exportsysMajorModule('upsertForm')">下载模板</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>
                </el-form>
             </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true" :data="tableData" @selection-change="changeFun"   @sort-change="sortChange" >
                <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column show-overflow-tooltip prop="code" label="专业代码" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="专业名称" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="考试安排" width="300">
                    <template slot-scope="scope">
                        <p v-for="items in scope.row.sysMajorItemList">
                            <span v-if="items.name" style="display: block;width: 90px;float: left">{{items.name}}</span>
                            <span v-if="items.examDay" style="margin-left: 10px">{{items.examDay}}</span>
                            <span v-if="items.examStartTime && items.examEndTime" style="margin-left: 10px">{{items.examStartTime}}~{{items.examEndTime}}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="year" label="生效年份" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="majorCode" label="专业编号" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80"  >
                    <template slot-scope="scope">
                        <el-dropdown>
                            <span class="el-dropdown-link" style="color: #409EFF">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><el-button type="text" v-display:sysMajor-update @click="toSaveOrUpdate($event,scope.row.id)">修改</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysMajor-look @click="toLook($event,scope.row.id)">查看</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysMajor-delete @click="deleteData(scope.row.id)">删除</el-button></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <el-pagination
                    style="margin-top: 10px;padding-bottom: 20px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.pager.totalCount"
                    :page-size="searchForm.pager.pageSize"
                    :current-page.sync="searchForm.pager.page"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
            ></el-pagination>
            <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
                <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <!--表格-->
                <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                        <el-table-column prop="code" label="专业代码"></el-table-column>
                        <el-table-column prop="name" label="专业名称"></el-table-column>
                        <el-table-column prop="updateTime" label="修改时间"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间"></el-table-column>
                </el-table>
            </div>
                <div v-if="dialogExcel.title=='导入'">
                    <el-upload class="lead-in-th"
                               style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                               :action="uploadUrl"
                               :headers="headers"
                               multiple
                               :show-file-list="false"
                               :on-success="handlesysMajorSuccess"
                               :before-upload="beforesysMajorUpload">
                        <div class="" style="width: 440px;height: 50px;">导入</div>
                    </el-upload>
                    <div class="lead-in-th" @click="exportsysMajorModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
                </div>
            </el-dialog>
            <!--批量修改-->
            <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="1000px" :visible.sync="batchDialog.dialogFormVisible">
                <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                    <el-form-item label="专业编码" prop="code">
                        <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.code" placeholder="请输入专业编码" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="专业名称" prop="name">
                        <el-input size="mini" maxlength="50" show-word-limit  v-model="upsertForm.name" placeholder="请输入专业名称" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="年份" prop="year">
                        <el-input-number style="width: 200px" v-model="upsertForm.year" size="mini"  label="请输入年份"></el-input-number>
                    </el-form-item>
                    <el-form-item label="专业名称" prop="majorCode">
                        <el-input size="mini" maxlength="2" show-word-limit  v-model="upsertForm.majorCode" placeholder="请输入专业编码名称" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="科目类型" prop="type">
                        <el-input-number style="width: 200px" v-model="upsertForm.type" size="mini"  label="请输入科目类型"></el-input-number>
                    </el-form-item>
                    <el-form-item label="考试须知" prop="xz">
                        <ckeditor v-model="upsertForm.xz"></ckeditor>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                    <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <save-or-update-sys-major v-if="saveOrUpdate.visible" v-bind="saveOrUpdate" @closeSaveOrUpdate="closeSaveOrUpdate"></save-or-update-sys-major>
        <look-sys-major v-if="look.visible" v-bind="look" :visible.sync="look.visible"></look-sys-major>

    </div>
</template>

<script>
    import axios from 'axios';
    import saveOrUpdateSysMajor from './saveOrUpdateSysMajor';
    import lookSysMajor from './lookSysMajor';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import ckeditor from "@/components/ckeditor-normal-math/editor.vue";
    export default {
        name: "sysMajor",
        components:{ckeditor, saveOrUpdateSysMajor,lookSysMajor,noData},
        data() {
            return {
                searchForm:{
                    adminId: '',
                    adminName: '',
                    code: '',
                    name: '',
                    year: '',
                    majorCode: '',
                    type: '1',
                    updateTime: '',
                    createTime: '',
                    pager:{
                        sortField:'year',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'createTime,code,name'
                    }
                },
                tableData: [],
                saveOrUpdate:{
                    visible:false,
                    title:'增加',
                    id:'',
                    type:'',
                },
                look:{
                    visible:false,
                    id:''
                },
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysMajor/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                rules: {
                  adminId: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  adminName: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  code: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  name: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  updateTime: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                  createTime: [
                          {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                      ],
                },
                yearList:[],
                typeList:[
                    {"name":"非模板科目","value":"1"},
                    {"name":"模板科目","value":"-1"}
                ],
                batchDialog:{
                    dialogFormVisible:false,
                    title:'批量修改'
                },
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    code:'',
                    name:'',
                    year:'',
                    majorCode:'',
                    type:'',
                    xz:'',
                    updateTime:'',
                    createTime:''
                },
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            toSaveOrUpdate($event,id){
                if(id){
                    this.saveOrUpdate.title='修改';
                    this.saveOrUpdate.id=id;
                    this.saveOrUpdate.type = this.searchForm.type;
                }else{
                    this.saveOrUpdate.title='增加';
                    this.saveOrUpdate.id=null;
                    this.saveOrUpdate.type = this.searchForm.type;
                }
                this.saveOrUpdate.visible=true;
            },
            closeSaveOrUpdate(data){
                this.saveOrUpdate.visible=false;
                data&&this.submit();
            },
            toLook($event,id){
                this.look={
                    visible:true,
                    id:id
                }
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysMajor/deleteSysMajor/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })

                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysMajor/findSysMajorsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            leadingInsysMajor() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportsysMajor() {
                axios({
                    url: `${home}/sysMajor/exportSysMajor`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysMajor.xls");
                });
            },
            exportsysMajorModule() {
                axios({
                    url: `${home}/sysMajor/exportSysMajorModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysMajor模板.xls");
                });

            },
            handlesysMajorSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforesysMajorUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysMajor/batchDeleteSysMajor`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            batchSave(){
                this.$prompt('请输入生效年份', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^(19|20)\d{2}$/,
                    inputErrorMessage: '年份格式不正确'
                }).then(({ value }) => {
                    axios({
                        url: `${home}/sysMajor/batchSaveSysMajorByYear/${value}`,
                        method: "GET",
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "复制成功!"
                        });
                        this.searchForm.type="1";
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            editModule(){
                this.searchForm.type='-1';
                this.submit();
            },
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.upsertForm.type=undefined;
                    this.upsertForm.year=undefined;
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/sysMajor/batchUpdateSysMajor`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
          batchSaveUpYear(){
            this.$confirm("确认复制上年度专业科目吗?", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              axios({
                url: `${home}/sysMajor/batchSaveUpYear`,
                method: "GET",
              }).then(res => {
                this.$message({
                  type: "success",
                  message: "复制成功!"
                });
                this.submit();
              }).catch(error => {});
            }).catch(() => {
              this.$message({
                type: "error",
                message: "删除失败!"
              });
            });
          }
        }
    }
</script>
